'use client'

import { type ComponentProps, useEffect } from 'react'
import { Modal } from '@/Modal/Modal'
import { setAdvertisingModalOpenState } from './advertisingModalState'

/** Shared advertising dialog behavior for standard forms and custom campaigns. */
export function AdvertisingModalShell(props: ComponentProps<typeof Modal>) {
  useEffect(() => {
    if (!props.isOpen) return
    setAdvertisingModalOpenState(true)
    return () => setAdvertisingModalOpenState(false)
  }, [props.isOpen])

  return <Modal {...props} />
}
